import axios from "axios";
import http from "./http";
import { SignedUrlRoot } from "../types/SignedUrl.types";

export const uploadFile = async (file: any, type: string) => {
  const fileObj = {
    assets: [{ fileName: file.name, type }],
  };
  const res = await http.post("/assets/get_upload_urls", fileObj);
  await axios.put(res.data.data?.[0]?.presignedUploadUrl, file, {
    headers: { "Content-Type": res.data.data?.[0]?.mimeType },
  });
  return res.data.data?.[0]?.postUploadImageUrl;
};

export const builderGetUploadUrl = async (
  file: File,
  studyId: string | undefined,
  formId: string,
  formLevel: "platform" | "study" | ""
) => {
  const fileObj = { fileName: file.name };

  const prefix =
    formLevel === "platform" ? "/admin/registry/" : `/study/${studyId}/`;

  const res = await http.post<SignedUrlRoot>(
    `${prefix}forms/${formId}/get_upload_url`,
    fileObj
  );

  await axios.put(res.data.data.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};

export const themeUploadUrl = async (file: File, studyId: string) => {
  const obj = { studyId: studyId, fileName: file.name };
  const res = await http.post<SignedUrlRoot>(`/ui/get_upload_url`, obj);
  await axios.put(res?.data?.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};

export const organisationUploadUrl = async (
  file: File,
  orgnizationId: string
) => {
  const obj = { orgnizationId: orgnizationId, fileName: file.name };
  const res = await http.post(`/organizations/get_upload_url`, obj);
  await axios.put(res?.data?.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const responsesGetUploadUrl = async (
  file: File,
  studyId?: string,
  participantId?: string,
  surveySlug?: string,
  surveyAssignmentId?: string,
  screeningAttemptId?: string,
  isParticipant?: boolean,
  isRegistryParticipant?: boolean
) => {
  const fileObj = { fileName: file.name };
  let params: any = {};

  if (participantId) {
    params["participantId"] = participantId;
  }

  const res = await http.post<SignedUrlRoot>(
    surveySlug
      ? `/survey/${surveySlug}/get_upload_url`
      : surveyAssignmentId
      ? isParticipant
        ? `/study/${studyId}/participant-survey-responses/get_upload_url`
        : `/study/${studyId}/survey-responses/get_upload_url`
      : isParticipant
      ? `/study/${studyId}/participant-screening-responses/get_upload_url`
      : screeningAttemptId
      ? isRegistryParticipant
        ? `/registry/admin-screening-responses/get_upload_url`
        : `/study/${studyId}/admin-screening-responses/get_upload_url`
      : `/study/${studyId}/responses/get_upload_url`,
    fileObj,
    { params }
  );

  await axios.put(res.data.data.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data.postUploadImageUrl;
};

export const consentUploadFile = async (
  file: any,
  studyId: string | undefined,
  type: string
) => {
  const fileObj = {
    fileName: file.name,
  };
  const prefix =
    type === "platform" ? `/platform/admin/` : `/admin/study/${studyId}/`;
  const res = await http.post(`${prefix}econsent/get_upload_url`, fileObj);
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const consentBuilderGetUploadUrl = async (
  file: File,
  studyId: string | undefined,
  formId: string,
  versionId: string,
  type: string,
  formType: "consent" | "sunshine" | ""
) => {
  const fileObj = { fileName: file.name };

  const prefix =
    type === "platform"
      ? `/platform/admin/econsent`
      : formType === "sunshine"
      ? `/admin/study/${studyId}/sunshine`
      : `/admin/study/${studyId}/econsent`;

  const res = await http.post<SignedUrlRoot>(
    `${prefix}/${formId}/version/${versionId}/get_upload_url`,
    fileObj
  );

  await axios.put(res.data.data.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};

export const medicationImageUpload = async (
  file: any,
  studyId: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/admin/study/${studyId}/medications/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res.data.data;
};

export const instrumentUploadFile = async (file: any) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(`/instrument-library/get_upload_url`, fileObj);
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const documentUploadFile = async (
  file: any,
  studyId: string | undefined,
  participantId: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/study/${studyId}/participants/${participantId}/documents/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const customizationUpload = async (
  file: any,
  studyId: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/admin/study/${studyId}/recipes/get_upload_url`,
    // `/admin/study/${studyId}/app-configurables/mobile/home/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res.data.data;
};
export const exerciseCollectionUpload = async (
  file: any,
  type: string,
  studyId: string | undefined,
  id: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  let url: string;
  switch (type) {
    case "exercise_collection":
      url = `/admin/study/${studyId}/exercise-collections/get_upload_url`;
      break;
    case "exercise_category":
      url = `/admin/study/${studyId}/exercise-collections/${id}/get_upload_url`;
      break;
    case "builder":
      url = `/admin/study/${studyId}/exercises/get_upload_url`;
      break;
    default:
      url = `/admin/study/${studyId}/exercise-collections/get_upload_url`;
      break;
  }
  const res = await http.post(url, fileObj);
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res.data.data;
};

export const educationModuleUploadFile = async (
  file: any,
  studyId: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/admin/study/${studyId}/lms/lessons/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};
export const learningModuleUploadFile = async (
  file: any,
  studyId: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/admin/study/${studyId}/lms/categories/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const unitUploadFile = async (
  file: any,
  studyId: string | undefined,
  lessonId: string | undefined
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/admin/study/${studyId}/lms/lessons/${lessonId}/units/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const sectionUploadFile = async (
  file: any,
  studyId: any,
  lessonId: any,
  unitId: any
) => {
  const fileObj = {
    fileName: file.name,
  };
  const res = await http.post(
    `/admin/study/${studyId}/lms/lessons/${lessonId}/units/${unitId}/pages/sections/get_upload_url`,
    fileObj
  );
  await axios.put(res.data.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return res?.data?.data;
};

export const studyDocumentUploadUrl = async (file: File, studyId: string) => {
  const fileObj = { fileName: file.name };

  const res = await http.post<SignedUrlRoot>(
    `/study/${studyId}/documents/get_upload_url`,
    fileObj
  );

  await axios.put(res.data.data.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};

export const landingPageImageUploadUrl = async (
  file: File,
  studyId?: string
) => {
  const obj: any = { fileName: file.name };
  if (studyId) obj.studyId = studyId;

  const url = studyId
    ? `/ui/get_upload_url`
    : `/admin/registry/ui/get_upload_url`;

  const res = await http.post<SignedUrlRoot>(url, obj);

  await axios.put(res?.data?.data?.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};

export const registryParticipantDocumentUploadUrl = async (
  file: File,
  participantId: string
) => {
  const fileObj = { fileName: file.name };

  const res = await http.post<SignedUrlRoot>(
    `/participant-documents/registry/get_upload_url?participantId=${participantId}`,
    fileObj
  );

  await axios.put(res.data.data.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};

export const studyParticipantDocumentUploadUrl = async (
  file: File,
  studyId: string,
  participantId: string
) => {
  const fileObj = { fileName: file.name };

  const res = await http.post<SignedUrlRoot>(
    `/participant-documents/study/${studyId}/get_upload_url?participantId=${participantId}`,
    fileObj
  );

  await axios.put(res.data.data.presignedUploadUrl, file, {
    headers: { "Content-Type": file.type },
  });

  return res.data.data;
};
